export default __webpack_public_path__ + "static/media/sliderMobile_3.537859d9.jpg";